import { Injectable } from '@angular/core';
import { DomainAdapter } from './domain.adapter';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DomainInfo } from './domain-info';
import { ENDPOINTS } from '@app/core/constants/endpoints';
import { HttpClientSkippingInterceptorsService } from '../http-client-skipping-interceptors.service';

@Injectable()
export class DomainService {
    constructor(
        private http: HttpClientSkippingInterceptorsService,
        private adapter: DomainAdapter
    ) {}

    public getDomainInfo(subdomain: string): Observable<DomainInfo> {
        return this.http
            .get(`${ENDPOINTS.apis.domains}/${subdomain}`)
            .pipe(map((data: any) => this.adapter.adapt(data)));
    }

    public getDomainAsset(subdomain: string, asset: string): Observable<string> {
        return this.http
            .request('GET', `${ENDPOINTS.apis.domains}/${subdomain}/${asset}`, {
                responseType: 'blob',
            })
            .pipe(map((blob) => URL.createObjectURL(blob)));
    }
}
